import axios from '../axios';

export const setResource = (resourceName, payload) => ({
  type: `resources.${resourceName}.set`,
  payload, // data
});

export const updateResource = (resourceName, payload) => ({
  type: `resources.${resourceName}.update`,
  payload, // { id, data }
});

export const deleteResource = (resourceName, payload) => ({
  type: `resources.${resourceName}.delete`,
  payload, // id
});

// since setResource(resourceName, {}) will always update the state (not overwrite)
export const overwriteResource = (resourceName, payload) => ({
  type: `resources.${resourceName}.overwrite`,
  payload,
});

// overwrite state by default
export const getAllData =
  (resourceName, query = '', overwrite = true) =>
  async () => {
    return await axios.get(`/${resourceName}?${query}`, {
      headers: {
        resourceName,
        overwrite,
      },
    });
  };

// update state by default
export const getDataById =
  (resourceName, id, query = '', overwrite = false) =>
  async () => {
    const res = await axios.get(`/${resourceName}/${id}?${query}`, {
      headers: {
        resourceName,
        overwrite,
      },
    });
    return res;
  };

export const updateData =
  (resourceName) =>
  (id, update, query = '') =>
  async (dispatch) => {
    const res = await axios.patch(`/${resourceName}/${id}?${query}`, update, {
      headers: {
        resourceName,
      },
    });
    dispatch(updateResource(resourceName, { id: res.data.id, data: res.data }));
    return res;
  };

export const addData = (resourceName) => (payload) => async (dispatch) => {
  const res = await axios.post(`/${resourceName}`, payload, {
    headers: {
      resourceName,
    },
  });
  dispatch(updateResource(resourceName, { id: res.data.id, data: res.data }));
  return res;
};

export const deleteData = (resourceName, id) => async (dispatch) => {
  await axios.delete(`/${resourceName}/${id}`);
  return dispatch(deleteResource(resourceName, id));
};

export const uploadProfilePhoto =
  (resourceName) =>
  (id, update, query = '') =>
  async (dispatch) => {
    const res = await axios.post(
      `/${resourceName}/${id}/pictures?${query}`,
      update,
      {
        headers: {
          resourceName,
        },
      }
    );
    dispatch(updateResource(resourceName, { id: res.data.id, data: res.data }));
    return res;
  };
